function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChangeStartDatei = function SvgChangeStartDatei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M15.77 4.551v-.816a.734.734 0 1 1 1.47 0v.816h2.108c.912 0 1.653.74 1.653 1.653v13.143c0 .912-.74 1.653-1.653 1.653H4.62a1.654 1.654 0 0 1-1.653-1.653V6.204c0-.913.74-1.653 1.653-1.653h2.107v-.816a.735.735 0 0 1 1.47 0v.816h2.998v-.816a.734.734 0 1 1 1.47 0v.816zm3.761 5.817H4.437v8.979c0 .101.083.184.184.184h14.727a.184.184 0 0 0 .183-.184zM9.597 12.7c0-.792-.643-1.435-1.434-1.435h-1.4c-.791 0-1.433.643-1.433 1.435v1.4c0 .791.642 1.433 1.433 1.433h1.4c.791 0 1.434-.642 1.434-1.434zm-2.798.035v1.329h1.329v-1.33zm10.44-6.714v.816a.735.735 0 0 1-1.468 0v-.816h-3.105v.816a.736.736 0 0 1-1.47 0v-.816H8.198v.816a.735.735 0 0 1-1.47 0v-.816H4.621a.184.184 0 0 0-.184.183V8.9H19.53V6.204a.184.184 0 0 0-.183-.183z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChangeStartDatei);
export default ForwardRef;